import { render } from "./HeroiconsSolidFilm.vue?vue&type=template&id=4aca2477"
const script = {}

import exportComponent from "/home/harlan/sites/kintell-env/api/packages/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidFilm.vue"]])

export default __exports__